import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { Typography, Divider, Space } from 'antd';
import {
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
  LinkedinOutlined
} from '@ant-design/icons';

const { Text, Title } = Typography;

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">

        <div className="footer__main">
          {/* Brand/About Section */}
          <div className="footer__column footer__brand">
            <Title level={4} className="footer__title">e-commerce</Title>
            <Text className="footer__text">
              The premier destination for premium tech, gadgets, and lifestyle products. Quality guaranteed since 2026.
            </Text>
          </div>

          {/* Customer Service */}
          <div className="footer__column">
            <Title level={5} className="footer__subtitle">Customer Service</Title>
            <ul className="footer__list">
              <li><Link to="/orders" className="footer__link">Track Order</Link></li>
              <li><Link to="/returns" className="footer__link">Returns Policy</Link></li>
            </ul>
          </div>

          {/* Legal Pages */}
          <div className="footer__column">
            <Title level={5} className="footer__subtitle">Legal Matters</Title>
            <ul className="footer__list">
              <li><Link to="/terms" className="footer__link">Terms of Service</Link></li>
              <li><Link to="/privacy" className="footer__link">Privacy Policy</Link></li>
              <li><Link to="/returns" className="footer__link">Refund Policy</Link></li>
            </ul>
          </div>
        </div>

        <Divider style={{ borderColor: '#334155' }} />

        <div className="footer__bottom">
          <Text className="footer__copyright">
            © {currentYear} e-commerce Inc. All rights reserved.
          </Text>
          <Space split={<Divider type="vertical" style={{ borderColor: '#475569' }} />}>
            <Link to="/privacy" className="footer__bottomLink">Privacy</Link>
            <Link to="/terms" className="footer__bottomLink">Terms</Link>
          </Space>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
